import React, { useState } from "react";
import { toast } from "sonner";
import { Btn, Field, Input } from "./ui";
import { errMsg } from "./api";

export const ForgotForm = ({ client, onBack }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await client.post("/auth/forgot-password", { email });
      setDone(data.mensaje);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="p-6 space-y-4" data-testid="portal-forgot">
      <h2 className="font-headings uppercase text-lg text-[#0A192F]">¿Olvidaste tu contraseña?</h2>
      {done ? (
        <p className="text-sm bg-emerald-50 border border-emerald-300 text-emerald-800 p-3" data-testid="portal-forgot-ok">{done} Revisá también la carpeta de spam.</p>
      ) : (
        <>
          <p className="text-sm text-gray-600">Escribí el email de tu cuenta y te mandamos un enlace para crear una nueva. Vence en 1 hora.</p>
          <Field label="Email *"><Input required type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="portal-forgot-email" /></Field>
          <Btn type="submit" variant="gold" busy={busy} className="w-full !py-3" data-testid="portal-forgot-submit">Enviarme el enlace</Btn>
        </>
      )}
      <button type="button" onClick={onBack} className="block mx-auto text-xs text-gray-500 underline" data-testid="portal-forgot-back">Volver a ingresar</button>
    </form>
  );
};

export const ResetForm = ({ client, token, onDone }) => {
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw !== pw2) return setError("Las contraseñas no coinciden.");
    setBusy(true);
    try {
      await client.post("/auth/reset-password", { token, password: pw });
      onDone("Listo, tu contraseña cambió. Ya podés ingresar con la nueva.");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="p-6 space-y-4" data-testid="portal-reset">
      <h2 className="font-headings uppercase text-lg text-[#0A192F]">Crear nueva contraseña</h2>
      <Field label="Nueva contraseña * (mín. 8)"><Input required type="password" minLength={8} autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="portal-reset-password" /></Field>
      <Field label="Repetila *"><Input required type="password" minLength={8} autoComplete="new-password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="portal-reset-password2" /></Field>
      {error && <p className="text-sm text-red-600" data-testid="portal-reset-error">{error}</p>}
      <Btn type="submit" variant="gold" busy={busy} className="w-full !py-3" data-testid="portal-reset-submit">Guardar contraseña</Btn>
      <button type="button" onClick={() => onDone("")} className="block mx-auto text-xs text-gray-500 underline">Cancelar</button>
    </form>
  );
};
